import {
  Button,
  Card,
  message,
  Space,
  Modal,
  Form,
  Input,
  Row,
  Col,
  Popconfirm,
} from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import TableComponent from "../common/table/TableComponent";
import { DeleteOutlined } from "@ant-design/icons";

function StudentPaymentTable() {
  const [confirmDeletePCLoading, setConfirmDeletePCLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm();
  const [authorisePaymentResponse, authorisePaymentRequest] = useApi(
    "/admin/student-payments/authorise",
    null,
    API_METHODS.PUT
  );

  const columns = [
    {
      title: "Student Name",
      dataIndex: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Razorpay Order Id",
      dataIndex: "razorpay_order_id",
    },
    {
      title: "Subscription Name",
      dataIndex: "subscription_name",
    },
    {
      title: "Date and Time",
      dataIndex: "created_on",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          {
            <Space>
              <Button size="small" onClick={() => authoriseClicked(record)}>
                Authorise
              </Button>

              <Popconfirm
                title="Delete Daily Content"
                description={`Are you sure to delete ?`}
                onConfirm={() => deleteOk(record)}
                trigger={"click"}
                okButtonProps={{
                  loading: confirmDeletePCLoading,
                }}
                placement="rightTop"
              >
                <Button size="small">
                  <DeleteOutlined style={{ color: "red" }} />
                </Button>
              </Popconfirm>
            </Space>
          }
        </>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    `/admin/student-payments/not-completed?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );

  const [deleteResponse, deleteRequest] = useApi(
    `/admin/student-payments/not-completed`,
    null,
    API_METHODS.DELETE
  );

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  const authoriseClicked = (record) => {
    setVisible(true);
    setSelectedRecord(record);
  };

  const handleCancel = () => {
    setVisible(false);
    setSelectedRecord(null);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        authorisePaymentRequest(
          values,
          API_METHODS.PUT,
          `/admin/student-payments/authorise/${selectedRecord.id}`
        );
      })
      .catch((e) => {});
  };

  useEffect(() => {
    if (authorisePaymentResponse.data) {
      setVisible(false);
      setSelectedRecord(null);
      messageApi.open({
        type: "success",
        content: "Payment Authorise Successfully.",
      });
      getRequest();
    } else if (authorisePaymentResponse.error) {
      setVisible(false);
      setSelectedRecord(null);
    }
  }, [authorisePaymentResponse]);

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/admin/student-payments/not-completed?pageNumber=${page.current}`
    );
    setCurrentPage(page.current);
  };

  const deleteOk = (record) => {
    setConfirmDeletePCLoading(true);
    deleteRequest(
      null,
      API_METHODS.DELETE,
      `/admin/student-payments/not-completed/${record.id}`
    );
  };

  useEffect(() => {
    if (deleteResponse.data && !deleteResponse.isLoading) {
      getRequest();
      message.success("Deleted Successfully.");
      setConfirmDeletePCLoading(false);
    }
  }, [deleteResponse]);

  return (
    <Card title="Non completed Payments">
      {contextHolder}
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />

      <Modal
        title="Authorise Payment"
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        okText="Save"
      >
        <Form layout="vertical" form={form}>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="razorpay_payment_id"
                label="Razorpay Payment Id"
                rules={[
                  {
                    required: true,
                    message: "Razorpay Payment Id is required.",
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Card>
  );
}

export default StudentPaymentTable;
